module.exports = __webpack_public_path__ + "static/media/Desktop.7cf5f9e0.svg";